import { ArrowBack, CheckCircle, Print } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

export default function PrintMenu({
  previewText = 'Previewing Estimate',
  fallbackTo = '/',
  onComplete = null,
  showCompleteButton = false,
}) {
  const location = useLocation();
  const navigate = useNavigate();

  const handleBack = () => {
    if (fallbackTo) {
      if (typeof fallbackTo === 'string') {
        navigate(fallbackTo, { replace: true });
        return;
      }

      navigate(fallbackTo.pathname, {
        replace: true,
        state: fallbackTo.state,
      });
      return;
    }

    if (location.key !== 'default') {
      navigate(-1);
      return;
    }

    navigate(fallbackTo, { replace: true });
  }

  const handlePrint = () => {
    window.print();
  }

  return (
    <>
      {/* Top menu - hidden during print */}
      <Box sx={{
        padding: '16px',
        margin: '-50px auto 0',
        backgroundColor: '#f5f5f5',
        borderBottom: '1px solid #ddd',
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        position: 'sticky',
        top: 0,
        zIndex: 1100,
        '@media print': {
          display: 'none',
        },
      }}>
        <Button
          startIcon={<ArrowBack />}
          onClick={handleBack}
          variant="outlined"
          size="small"
        >
          Back
        </Button>
        <Button
          startIcon={<Print />}
          onClick={handlePrint}
          variant="outlined"
          size="small"
        >
          Print
        </Button>
        {showCompleteButton && onComplete && (
          <Button
            startIcon={<CheckCircle />}
            onClick={onComplete}
            variant="outlined"
            size="small"
          >
            Complete
          </Button>
        )}
        <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#666' }}>
          {previewText}
        </Typography>
      </Box>
    </>
  )
}